import React from "react";
import gif from "../assets/gif2.gif";
import "./Css/Loading.css";
function Loader() {
  return (
    <>
      <div className="loaderContrr">
        {" "}
        <figure className="loader">
          <div className="car">
            <span className="body"></span>
            <span className="wheels"></span>
          </div>
          <div className="strikes">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </figure>
      </div>
    </>
  );
}

export default Loader;
